import ajaxRequest from './ajaxRequest';
import getFormDataJson from './getFormDataJson';
import initMiniCart from '../pages/global/header/miniCart';
import { API, AddToCartData } from '../types';
import { trackAddToCart } from '../analytics';

export function addToCartHandler(formElement: HTMLFormElement): Promise<AddToCartData> {
  const formData = getFormDataJson(formElement);

  return ajaxRequest<AddToCartData>({
    method: 'POST',
    url: formElement.id === 'giftCardForm' ? API.ADD_GIFTCARD_TO_CART : API.ADD_TO_CART,
    data: formData
  }).then((responseData) => {
    if (!responseData.errorMessage) {
      trackAddToCart(responseData);
    }

    return responseData;
  });
}

export function emptyVariantSelectorHandler(errorMessage: string): void {
  const variantSelectors = document.querySelectorAll('.variant-select');
  const errorContainer = document.getElementById('variantErrorContainer');

  if (errorContainer) {
    errorContainer.innerHTML = errorMessage;
  }

  Array.from(variantSelectors).forEach((variantSelector) => {
    variantSelector.classList.add('parsley-error');
  });
}

export function addToCartDisabledButtonHandler(): void {
  document.addEventListener('click', (e: Event) => {
    const addToCartDisabledButtonElement = (e.target as Element).closest('.add-to-cart-disabled-button');
    if (addToCartDisabledButtonElement) {
      emptyVariantSelectorHandler('Please select a size before adding to your bag');
    }
  });
}

export function addToCartFormHandler(): void {
  const addToBagFormElements = document.querySelectorAll<HTMLFormElement>('.add_to_cart_form');
  [...addToBagFormElements].forEach((formElement) => {
    const addToBagButtonElement = formElement.querySelector<HTMLButtonElement>('button[type=submit]');
    addToBagButtonElement?.classList.remove('disabled');
    addToBagButtonElement?.removeAttribute('disabled');

    formElement.addEventListener('submit', (e: Event) => {
      e.preventDefault();
      sendFormData(formElement);
    });
  });
}

export function sendFormData(formElement: HTMLFormElement): void {
  if (window.bbGlobal.miniCartData.isInitialDataFetched && window.bbGlobal.miniCartData.isDataFetching === false) {
    window.bbGlobal.miniCartData.isDataFetching = true;
    const submitButtonElement = formElement.querySelector('[type="submit"]');
    submitButtonElement?.classList.add('_is-loading');

    addToCartHandler(formElement)
      .then(updateMiniCart)
      .catch(() => {})
      .finally(() => {
        window.bbGlobal.miniCartData.isDataFetching = false;
        submitButtonElement?.classList.remove('_is-loading');
      });
  }
}

export function updateMiniCart({
  entries,
  totalEntryQuantities,
  miniCartDisplayLimit,
  subtotal,
  errorMessage,
  entry
}: AddToCartData): void {
  const { updateMiniCartPopupMarkup, updateMiniCartGlobalState, updateMiniCartMarkup } = initMiniCart();
  updateMiniCartGlobalState({ entries, miniCartDisplayLimit, totalEntryQuantities });
  updateMiniCartMarkup({ entries, miniCartDisplayLimit, totalEntryQuantities, subtotal });
  updateMiniCartPopupMarkup({ isError: Boolean(errorMessage), entry, subtotal, errorMessage });
}
